export const USER_HAS_NOT_RECIPIENT_ASSOCIATED =
  'An associated customer with this account has not been set, please contact support.';
export const SIGN_UP_FORM_TITLE =
  'Please enter your details, we will process it and send you an email when your account is ready to use.';
export const REQUEST_ACCOUNT_SUCCESS = 'Account requests created successfully.';
export const REQUEST_ACCOUNT_ALREADY_EXIST = 'Account requests already exists.';
export const REQUEST_ACCOUNT_ERROR = 'An error occurred while trying to create the acccount requests.';
export const SUCCESS = 'success';
export const ERROR = 'error';
